import React from "react";
import { Link } from "react-router-dom";

const CancelModal = () => {
  const redirectHandler = () => {
    setTimeout(function () {
      window.location.replace("/dashboard");
    }, 2000);
  };
  return (
    <>
      {/* <!-- delete modal --> */}
      <div
        className="modal fade"
        id="modal-delete"
        tabIndex="-1"
        style={{ display: "none" }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <button
                type="button"
                className="btn-close text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0 pb-4">
              <h5 className="mb-4 text-center">
                Are you sure you want to cancel appointment?
              </h5>
              <div className="gth-confirmation-btn mx-auto d-flex justify-content-center">
                <Link to="/dashboard" className="btn btn-primary btn-xs me-3">
                  Yes
                </Link>
                <a
                  href="#"
                  data-bs-dismiss="modal"
                  className="btn btn-outline btn-xs"
                >
                  No
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancelModal;
